var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_317_3598",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 58,
    height: 58
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 29,
    cy: 29,
    r: 29,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_317_3598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -77.7725,
    y: -17.7954,
    width: 223.432,
    height: 139.068,
    fill: "#46399D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7441 24.2561C20.7441 28.7969 24.4594 32.5121 29.0002 32.5121C33.541 32.5121 37.2563 28.7969 37.2563 24.2561C37.2563 19.7152 33.541 16 29.0002 16C24.4594 16 20.7441 19.7152 20.7441 24.2561ZM35.3137 24.2561C35.3137 27.7285 32.4726 30.5695 29.0002 30.5695C25.5278 30.5695 22.6867 27.7285 22.6867 24.2561C22.6867 20.7837 25.5278 17.9426 29.0002 17.9426C32.4726 17.9426 35.3137 20.7837 35.3137 24.2561Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3841 41.3817C21.9581 38.8077 25.3576 37.3994 29 37.3994C32.6424 37.3994 36.0419 38.8077 38.6159 41.3817L40 39.9976C37.0618 37.0837 33.1523 35.4567 29 35.4567C24.8477 35.4567 20.9382 37.0837 18 39.9976L19.3841 41.3817Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile01);
export default __webpack_public_path__ + "static/media/profile-01.b53e2a2b2d7c4b37cae6bd887efd759f.svg";
export { ForwardRef as ReactComponent };